export const labExamCopy = {
  modalTitle: "Lab work required",
  acknowledgmentParagraph1: (medicationName: string) =>
    `${medicationName} requires a simple blood test before it can be prescribed. This test helps your provider confirm that the medication is safe and appropriate for you.`,
  acknowledgmentParagraph2:
    "After you submit your consultation, your provider will order the required lab work as part of your consultation (additional charges may apply).",
  acknowledgmentParagraph3:
    "Depending on your insurance plan, the cost of this one time laboratory test may be partially or fully covered by insurance.",
  checkoutTag: "Lab work required",
} as const;
